export default __webpack_public_path__ + "static/cx-260ba91796b58290e8f32bd06c22ffbb.svg";